import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'reactstrap';

import Grid from '../../components/cms/grid';
import AddNewButton from '../../components/cms/grid/addNewButton';
import ModelService from '../../services/subscriber.service';

const initCriteria = {
  order: 'desc',
  sortBy: 'id',
  id: '',
  first_name: '',
  last_name: '',
  status: '',
  username: '',
  email: '',
  phone: '',
};

const permissionToDelete = ['delete_subscribers'];
const permissionToCreate = ['create_subscribers'];

const Subscribers = ({ t, getColumns }) => (
  <div className="">
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-users" /> {t('Subscribers')}</strong>
          </CardHeader>
          <CardBody>
            <div className="pull-right mb-1">
              <AddNewButton
                to={ModelService.getCreateUrl()}
                icon="fa fa-user-plus"
                permissionToCreate={permissionToCreate}
              />
            </div>
            <Grid
              id="users"
              service={ModelService}
              columns={getColumns(t)}
              initCriteria={initCriteria}
              permissionToDelete={permissionToDelete}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Subscribers.propTypes = {
  t: PropTypes.func.isRequired,
  getColumns: PropTypes.func.isRequired,
};

export default Subscribers;



// WEBPACK FOOTER //
// ./src/views/subscribers/Subscribers.jsx